var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',{staticClass:"sf-footer"},[_c('div',{staticClass:"sf-footer__container",style:({ 'grid-template-columns': ' 1fr'.repeat(_vm.column) })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }